export default "__VITE_ASSET__B_sR4mNg__"